import React, { useEffect, useState } from 'react';
import { Button } from 'react-bootstrap';
import webSocket from 'socket.io-client'
import { SOCKETIO_URL } from '../../config';
import { setWebSocketConnect, getWebSocketConnect } from '../Login/doitSocket';
import { AddButton, RefuseButton, SearchButton, Space, SubmitButton } from '../Main/Res/BaseButton';
import { SingleInput, SingleMultilineText, SingleTextArea } from '../Main/Res/BaseInput';
import { IR_CREATE, IR_DATAPUSHING, IR_GAMEMAPPING } from './siSocketSt';

export function SocketWin() {
  const [ws, setWs] = useState(null)
  const [Key_Id, set_Key_Id] = useState("")
  const [status, set_status] = useState("")
  const [message, set_message] = useState("")

  useEffect(() => {
    console.log("A")
    connectWebSocket()
  }, [])

  const connectWebSocket = async () => {
    //開啟
    //setWs(webSocket(SOCKETIO_URL))
    await setWebSocketConnect(webSocket(SOCKETIO_URL))
    if (getWebSocketConnect()) {
      console.log('success connect!')
      //設定監聽
      initWebSocket()
    }
  }

  const initWebSocket = () => {
    //對 getMessage 設定監聽，如果 server 有透過 getMessage 傳送訊息，將會在此被捕捉
    getWebSocketConnect().on(IR_DATAPUSHING, message => {
      // console.log(message)
      // set_message(message)
    })
  }

  function send_mapping() {
    getWebSocketConnect().emit(IR_GAMEMAPPING, {"Key_Id":Key_Id}, (status) => {
      console.log(status)
      set_status(status)
    })
  }

  function send() {
    var js
    try{
      js = JSON.parse(message)
      console.log(js)
    }catch(e){
      // console.log(e)
      js = message
    }
    try{
      getWebSocketConnect().emit(IR_DATAPUSHING, js, (val) => {
        console.log(val)
        set_status(val)
      })
    }catch(e){
      console.log(e)
    }
  }

  return (
    <div className="row">
      <div className="col-md-10">
        <Space />
        <Space />
        <div className="row">
          <div className="col-md-10">
            <SingleInput val={Key_Id} size={2} action={set_Key_Id} />
            <SearchButton name={"mapping"} action={send_mapping} />
          </div>
        </div>
        <Space />
        <div className="row">
          <div className="col-md-12" style={{ background: 'white', color: 'black', minHeight: 100 }}>
            <SingleMultilineText val={JSON.stringify(status)} action={set_status} />
          </div>
        </div>
        {Key_Id !== "" ? <>
          <Space />
          <Space />
          <Space />
          <div className="row">
            <div className="col-md-12">
              <SingleTextArea val={message} action={set_message} />
            </div>
          </div>
          <Space />
          <Space />
          <Space />
          <div className="row">
            <div className="col-md-10">
              <SubmitButton name={"送出"} action={send} isRight={true} />
            </div>
          </div>
        </> : <></>}
      </div>
    </div>
  )
}